<template>
    <BaseDialog
        :showDialog="showDialog"
        maxDialogWidth="800"
        maxCardHeight="700"
        :scrollable="true"
        headline="lang_GENERIC_CAPTION_FIX_IT"
        :close="closeDialog"
        :alvqa="alvqa"
    >    
        <template v-slot:dialogText>
            <v-container fluid>

                <v-row class="pb-3">
                    <!-- Source (read-only) -->
                    <v-col cols="4">
                        <v-text-field
                            :value="sourceName"
                            :label="$t('lang_GENERIC_CAPTION_SOURCE')"
                            readonly
                            disabled
                        ></v-text-field>
                    </v-col>

                    <!-- Other ID (read-only) -->
                    <v-col cols="4">
                        <v-text-field
                            :value="otherId"
                            :label="$t('lang_PUBLISHING_WORKS_CAPTION_WORK_ID')"
                            readonly
                            disabled
                        ></v-text-field>
                    </v-col>

                    <!-- Country (dropdown) -->
                     
                    <v-col cols="4">
                        <BaseEditPageDropdown 
                            :context="context"
                            :label="$t('lang_GENERAL_CAPTION_COUNTRY')" 
                            :items="countryItems" 
                            field="Country"
                            :alvqa="alvqa + '-dropdown-country'"
                            :withMargin="false"
                        />
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="11">
                        <SearchFilter 
                            :context="searchContext" 
                            @keydown.enter="searchForWorks"
                            :alvqa="alvqa + '-textfield-search'"
                        />
                    </v-col>
                    <v-col align-self="end" class="text-right">
                        <BaseIcon 
                            @click="searchForWorks" 
                            icon="fa-search" 
                            tooltipText="lang_GENERIC_CAPTION_SEARCH"
                            :alvqa="alvqa + '-button-search'"
                        />
                    </v-col>
                </v-row>
                <v-divider v-if="works.length > 0"></v-divider>    
                <v-list two-line>
                    <v-list-item-group
                        v-model="selectedWork"
                        @change="selectWork"
                    >
                        <v-list-item
                            v-for="(work, i) in works"
                            :key="work.alvId"
                            :value="i"
                            :alvqa="alvqa + '-result-list-row-' + work.alvId"
                        >
                            <template v-slot:default="{ active }">
                                <v-list-item-content>
                                    <v-list-item-title :alvqa="alvqa + '-result-list-row-' + work.alvId + '-title'">
                                        {{ formatWorkTitle(work) }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle :alvqa="alvqa + '-result-list-row-' + work.alvId + '-subtitle'">
                                        <BaseTooltip
                                            :simpleText="formatComposers(work)"
                                            :alvqa="alvqa + '-result-list-row-' + work.alvId + '-subtitle-text'"
                                        />
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </template>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-container>
        </template>
        
        <template v-slot:dialogActions>
            <v-container fluid>
                <v-row>
                    <v-spacer />
                    <v-col class="text-right">
                        <BaseButton 
                            :disabled="selectedWork === null"
                            @click="apply"
                            label="lang_GENERIC_CAPTION_APPLY"
                            :alvqa="alvqa + '-button-apply'"
                        />
                    </v-col>
                </v-row>
            </v-container>        
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import SearchFilter from '@/components/_filters/SearchFilter'
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseHeaderStats from '@/components/_base/BaseHeaderStats'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseTooltip from '@/components/_base/BaseTooltip'

export default {
    name: "FixItSF102Dialog",
    props: {
        incomeFile: {
            type: Object,
            required: true
        }
    },
    components: {
        BaseDialog,
        SearchFilter,
        BaseIcon,
        BaseButton,
        BaseHeaderStats,
        BaseEditPageDropdown,
        BaseTooltip,
    },
    data() {
        return {
            context: "IncomeErrorListFixItSF102",
            searchContext: 'WorksForFixIt',
            showSearchResult: false,
            works: [],
            selectedWork: null,
            alvqa: 'publishing-income-list-dialog-fix-it-sf102'
        }
    },
    computed: {
        errorItem() {
            return this.$store.getters.getFixItSF102ErrorObject
        },
        sourceAlvId() {
            return this.incomeFile && this.incomeFile.sourceAlvId
                ? this.incomeFile.sourceAlvId
                : '';
        },
        sourceName() {
            return this.incomeFile && this.incomeFile.source
                ? this.incomeFile.source
                : '';
        },
        showDialog: {
            get() {
                return this.$store.getters.getShowFixItSF102Dialog;
            },
            set(value) {
                this.$store.commit('setShowFixItSF102Dialog', value);
            }
        },
        countryItems() {
            return this.$alvPlugin.getListOfTranslatedCountries()
        },
        errorItem() {
            return this.$store.getters.getFixItSF102ErrorObject;
        },
        // For the "Other ID" field (from workIdentifier)
        otherId() {
            return this.errorItem && this.errorItem.workIdentifier ? this.errorItem.workIdentifier : '';
        },
        incomeFileAlvId() {
            return this.incomeFile && this.incomeFile.alvId ? this.incomeFile.alvId : '';
        },
        // For the "Source" field (from licensor or kto, adjust as needed)
        source() {
            if (this.errorItem) {
            if (this.errorItem.licensor) {
                return this.errorItem.licensor;
            } else if (this.errorItem.kto) {
                return this.errorItem.kto;
            }
            }
            return '';
        },
        // For the Country dropdown (read/write in Vuex if desired)
        selectedCountry: {
            get() {
            return this.$store.getters.getFixItSF102NewCountry;
            },
            set(value) {
            this.$store.commit('setFixItSF102NewCountry', value);
            }
        },
    },
    methods: {
        async searchForWorks() {
            this.$store.commit('setIsLoading', true)
            this.works = await this.$store.dispatch('searchWorksForFixIt')
            this.showSearchResult = true
            this.$store.commit('setIsLoading', false)
        },
        formatWorkTitle(work) {
            // Gather the IDs you want to display
            const meta = []
            if (work.gemaNumber) meta.push(work.gemaNumber)
            if (work.iswc) meta.push(work.iswc)
            if (work.alvId) meta.push(work.alvId)

            // If no IDs, just return the title
            if (!meta.length) return work.title

            // Otherwise, "TITLE (id1, id2, id3)"
            return `${work.title} (${meta.join(', ')})`
        },
        formatComposers(work) {
            return Array.isArray(work.composers) ? work.composers.join(' | ') : ''
        },
        selectWork() {
            // Handle work selection if needed
        },
        apply() {
            if (this.selectedWork !== null) {
            // Retrieve the selected work from the search results array
            const selectedWorkObj = this.works[this.selectedWork];
            // Build the payload matching the agreed format
            const payload = {
                otherId: this.otherId,                     // e.g., "609571"
                sourceAlvId: this.sourceAlvId,             // e.g., "ALV000211902AG"
                country: this.$store.getters.getIncomeErrorListFixItSF102DetailsCountry,             // e.g., "AT" (can be empty if not selected)
                workAlvId: selectedWorkObj.alvId,          // e.g., "ALV000336121PW"
                incomeFileAlvId: this.incomeFileAlvId      // e.g., "ALV000093745PI"
            };
            // Dispatch the action with the payload
            this.$store.dispatch('fixItSF102', payload);
            this.closeDialog();
            }
        },
        closeDialog() {
            this.showDialog = false
            this.works = []
            this.selectedWork = null
            this.showSearchResult = false
        }
    },
    mounted() {
        this.$store.commit('setCountries')
        // If the error object has a work title, set it in the store
        if (this.errorItem && this.errorItem.title) {
            this.$store.commit('setWorksForFixItSearch', this.errorItem.title);
            
            // If you want the search to run automatically, also call:
            // this.searchForWorks();
        }
    },
}
</script>